import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { HttpErrorResponse } from '@angular/common/http';

// Varias llamadas en paralelo pueden devolver 401 casi al mismo tiempo (p.ej. al
// cargar el dashboard). Sin esta bandera, cada una dispara su propio toast +
// logout, apilando mensajes duplicados antes de que la primera navegación surta efecto.
let redirectingToLogin = false;

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const messageService = inject(MessageService);
    const router = inject(Router);

    const goToLogin = (severity: 'warn' | 'error' | 'info', summary: string, detail: string, path: string[] = ['/auth/login']) => {
        if (redirectingToLogin) return;
        redirectingToLogin = true;
        messageService.add({ severity, summary, detail });
        localStorage.removeItem('token');
        router.navigate(path).finally(() => { redirectingToLogin = false; });
    };

    return next(req).pipe(
        catchError((err: HttpErrorResponse) => {
            const apiMsg = err?.error?.error?.message || err?.error?.message;

            if (err?.status === 503) {
                messageService.add({
                    severity: 'warn', summary: 'Servicio no disponible',
                    detail: 'El servidor no puede procesar la solicitud en este momento. Intenta más tarde.',
                });
            } else if (err?.status === 401) {
                if (apiMsg?.includes('jwt expired')) {
                    goToLogin('warn', 'Sesión expirada', 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.');
                } else if (apiMsg === 'invalid corporate subscription') {
                    messageService.add({ severity: 'warn', summary: 'Suscripción inválida', detail: 'Suscripción corporativa inválida.' });
                    router.navigate(['/dashboard', 'plan']);
                } else if (apiMsg === 'User is not a corporate user') {
                    // Ya tiene cuenta Pitts (p.ej. aliado/taller de la app móvil)
                    // pero sin acceso corporativo. En vez de solo cerrar sesión,
                    // lo mandamos a completar el registro corporativo — el
                    // formulario de registro detecta el correo existente y lo
                    // convierte (ver register.component.ts) en vez de bloquearlo.
                    goToLogin(
                        'info',
                        'Agrega acceso corporativo',
                        'Ya tienes una cuenta Pitts. Completa el registro corporativo con el mismo correo para agregarle acceso.',
                        ['/auth/register'],
                    );
                } else {
                    goToLogin('error', 'No autorizado', apiMsg || 'No autorizado. Por favor, inicia sesión.');
                }
            } else if (err?.status === 500) {
                // Solo mostrar toast genérico si el componente no va a manejar el error con mensaje propio
                const detail = apiMsg || 'Ocurrió un error inesperado. Intenta más tarde.';
                messageService.add({ severity: 'error', summary: 'Error', detail });
            }
            console.error('Interceptor error:', err);
            return throwError(() => err);
        })
    );
};